import React, {useMemo} from 'react';
import HeadlineProps from './headline.props';
import {TypographySizes, TypographyVariants} from '../base-text/constants';
import BaseText from '../base-text/base-text.component';

const Headline = ({
  size = TypographySizes.M,
  ...baseTextProps
}: HeadlineProps) => {
  const variant = useMemo(() => {
    switch (size) {
      case TypographySizes['3XL']:
        return TypographyVariants.Headline1;
      case TypographySizes['2XL']:
        return TypographyVariants.Headline2;
      case TypographySizes.XL:
        return TypographyVariants.Headline3;
      case TypographySizes.L:
        return TypographyVariants.Headline4;
      case TypographySizes.M:
        return TypographyVariants.Headline5;
      case TypographySizes.S:
      case TypographySizes.XS:
      default:
        return TypographyVariants.Headline6;
    }
  }, [size]);
  return <BaseText {...baseTextProps} size={size} variant={variant} />;
};

export default Headline;
